class ContractDropdownController {
  constructor($scope, $rootScope, $http, $timeout, $element) {
    "ngInject";
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$element = $element;

    const self = this;
    
    this.searchText = '';
    this.isOpen = false;
    this.contracts = [];
    this.filteredContracts = [];
    this.loading = false;
    this.page = 0;
    this.pageSize = 20;
    this.hasMore = true;
    this.allContractsLoaded = false;
    this.mouseInDropdown = false;
    
    // Initialize search text if contract is pre-selected
    if (this.selectedContract) {
      this.searchText = this.selectedContract.contractName || '';
    }
    
    // Load initial contracts
    this.loadContracts();
    
    // Watch for changes to selectedContract from outside
    $scope.$watch(() => this.selectedContract, (newVal) => {
      if (newVal && newVal.contractName) {
        this.searchText = newVal.contractName;
      } else if (!newVal) {
        this.searchText = '';
      }
    });

    $scope.$watch(
      () => this.filterCustomerId,
      function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        self.selectedContract = null;
        self.searchText = '';
        self.loadContracts(true);
      }
    );
    
    // Setup scroll listener after view init
    $scope.$on('$destroy', () => {
      if (this.scrollElement) {
        this.scrollElement.removeEventListener('scroll', this.scrollHandler);
      }
    });
  }
  
  
  loadContracts(reset = false) {
    if (this.loading) return;
    
    this.loading = true;
    
    if (reset) {
      this.page = 0;
      this.contracts = [];
      this.hasMore = true;
    }
    
    let url = this.$rootScope.apiHost + "/api/admin/contracts";
    if (this.filterCustomerId != null && this.filterCustomerId !== '') {
      url = this.$rootScope.apiHost + "/api/admin/contracts/bycustomer?customer=" + encodeURIComponent(this.filterCustomerId);
    }

    this.$http.get(url, { withCredentials: true })
      .then((response) => {
        let contractsData = response.data || [];
        
        // Sort contracts alphabetically by contractName
        contractsData.sort((a, b) => {
          const nameA = (a.contractName || '').toLowerCase();
          const nameB = (b.contractName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        
        if (reset) {
          this.contracts = contractsData;
        } else {
          this.contracts = [...this.contracts, ...contractsData];
          // Re-sort the combined array
          this.contracts.sort((a, b) => {
            const nameA = (a.contractName || '').toLowerCase();
            const nameB = (b.contractName || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
        }
        
        this.allContractsLoaded = true;
        this.filterContracts();
        this.loading = false;
      })
      .catch((error) => {
        console.error('Error loading contracts:', error);
        this.loading = false;
      });
  }
  
  filterContracts() {
    if (!this.searchText || this.searchText.trim() === '') {
      this.filteredContracts = this.contracts.slice(0, this.pageSize);
      this.hasMore = this.contracts.length > this.pageSize;
    } else {
      const searchLower = this.searchText.toLowerCase();
      this.filteredContracts = this.contracts.filter(contract => 
        contract.contractName && contract.contractName.toLowerCase().includes(searchLower)
      ).slice(0, this.pageSize);
      this.hasMore = false; // Don't show "load more" when filtering
    }
  }
  
  onSearchChange() {
    this.filterContracts();
  }
  
  onInputFocus() {
    this.isOpen = true;
    this.filterContracts();
    this.setupScrollHandler();
  }
  
  setupScrollHandler() {
    // Setup scroll handler when dropdown opens
    this.$timeout(() => {
      const element = this.$element[0].querySelector('.contract-dropdown-list');
      if (element && !this.scrollElement) {
        this.scrollElement = element;
        this.scrollHandler = (event) => {
          this.onScroll(event);
          this.$scope.$apply();
        };
        element.addEventListener('scroll', this.scrollHandler);
      }
    }, 50);
  }
  
  onInputBlur() {
    // Delay closing to allow click events to fire
    this.$timeout(() => {
      if (!this.mouseInDropdown) {
        this.isOpen = false;
      }
    }, 200);
  }
  
  onDropdownMouseEnter() {
    this.mouseInDropdown = true;
  }
  
  onDropdownMouseLeave() {
    this.mouseInDropdown = false;
    this.isOpen = false;
  }
  
  selectContract(contract) {
    this.selectedContract = contract;
    this.searchText = contract.contractName;
    this.isOpen = false;
    
    if (this.onSelect) {
      this.onSelect({ contract: contract });
    }
  }
  
  clearSelection() {
    this.selectedContract = null;
    this.searchText = '';
    this.isOpen = false;
    
    if (this.onSelect) {
      this.onSelect({ contract: null });
    }
  }
  
  onScroll(event) {
    const element = event.target;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    
    // Load more when scrolled to within 50px of bottom
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      this.loadMore();
    }
  }
  
  loadMore() {
    if (this.loading || !this.hasMore || (this.searchText && this.searchText.trim() !== '')) return;
    
    this.page++;
    const startIndex = this.page * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    
    const remainingContracts = this.contracts.slice(startIndex, endIndex);
    if (remainingContracts.length > 0) {
      this.filteredContracts = [...this.filteredContracts, ...remainingContracts];
      this.hasMore = endIndex < this.contracts.length;
    } else {
      this.hasMore = false;
    }
  }
  
  isSelected(contract) {
    return this.selectedContract && this.selectedContract.id === contract.id;
  }
}

export default ContractDropdownController;




// WEBPACK FOOTER //
// ./client/common/directives/contract-dropdown/contract-dropdown.controller.js